import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { merge, forEach, omit } from 'lodash';
import { first, tap } from 'rxjs/operators';
import { Survey, SurveyDataInterface } from '../../classes';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { getAllLeafPaths } from '@schoolbelle/common/object-change-tracker';
import * as _firebase from 'firebase/app';
import 'firebase/functions';
const firebase = _firebase;

export type SurveyChange = {
  to: Partial<SurveyDataInterface>;
  from: Partial<SurveyDataInterface>;
  timestamp: number;
};

@Injectable({
  providedIn: 'root'
})
export class SurveyService {
  constructor(private db: AngularFireDatabase, private auth: AuthService) {
  }

  private getSurveyDataFromChangeList(
    changes: SurveyChange[]
  ): Partial<SurveyDataInterface> {
    let ob = {};
    changes.forEach(change => {
      ob = merge(omit(ob, getAllLeafPaths(change.from)), change.to);
    });
    this.eliminateDeadLeave(ob);
    return ob as Partial<SurveyDataInterface>;
  }

  private eliminateDeadLeave(val: any) {
    if (val && typeof val === 'object') {
      forEach(val, (childVal, key) => {
        if (childVal && typeof childVal === 'object') {
          this.eliminateDeadLeave(childVal);
          if (Object.keys(childVal).length === 0) delete val[key];
        } else if (childVal === undefined || childVal === null) {
          delete val[key];
        }
      });
    }
    return val;
  }

  // get data(): Partial<SurveyDataInterface> {
  //   return this.getSurveyDataFromChangeList(this.changes);
  // }
  changes: SurveyChange[];
  data:Partial<SurveyDataInterface>;
  getLatest(survey_id: string): Observable<Partial<SurveyDataInterface>> {
    return this.db
      .object<Partial<SurveyDataInterface>>(`survey/${survey_id}`)
      .valueChanges()
      .pipe(
        first(),
        tap(data=>this.data = data),
      );
  }
  write(survey: Survey): Promise<string> {
    if (!survey.isChanged) return Promise.reject('nothing to commit');
    return firebase
      .functions()
      .httpsCallable('surveyWrite')(survey.value)
      .then(response => {
        survey.set('id', response.data.id);
        survey.set('version', response.data.version);
        survey.load(survey.value);
        return survey.id;
      });
  }
}
